import { SxProps, Theme } from '@mui/material';

const TOP_BAR_SPACE = 48;
const ENVIRONMENT_BANNER_SPACE = 48;

// Panels that slide in over the app content (not the browser window) portal into this element
export const LAYOUT_CONTENT_ID = 'layout-content';

export const LayoutStyles: SxProps<Theme> = {
  background:
    'radial-gradient(circle at top right, rgba(246, 131, 21, 0.08), transparent 28%), linear-gradient(180deg, #f7f8fa 0%, #eef1f4 100%)',
  height: '100dvh',
  overflow: 'hidden',
  p: 2,
  position: 'relative',
  width: '100%',
};

export const LayoutBackgroundStyles: SxProps<Theme> = {
  '@media (max-width: 1680px)': {
    display: 'none',
  },
  inset: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
};

export const LayoutShellStyles: SxProps<Theme> = {
  height: '100%',
  margin: '0 auto',
  maxWidth: '1600px',
  position: 'relative',
  width: '100%',
  zIndex: 1,
};

export const LayoutMainContentStyles: SxProps<Theme> = {
  backgroundColor: 'primary.bg',
  borderRadius: '14px',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  transition: 'width 0.3s',
  width: '100%',
};

export const getLayoutContainerStyles = (hasEnvironmentBanner: boolean): SxProps<Theme> => ({
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(255, 255, 255, 0.94)',
  borderRadius: '14px',
  boxShadow: '0 24px 64px rgba(17, 17, 17, 0.08)',
  height: `calc(100dvh - ${
    TOP_BAR_SPACE + (hasEnvironmentBanner ? ENVIRONMENT_BANNER_SPACE : 0)
  }px)`,
  mt: 2,
  overflow: 'hidden',
  p: 1,
  position: 'relative',
  width: '100%',
});

export const LayoutMainStyles: SxProps<Theme> = {
  height: '100%',
  overflow: 'auto',
  pb: 2,
};
